import React, { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import DesktopDashboardHeader from '../../organisms/desktopDashboard/DesktopDashboardHeader';
import DesktopSideBarMenu from '../../organisms/desktopDashboard/DesktopSideBarMenu';

interface Props {
  children?: React.ReactNode;
}

const WrapperDiv = styled.div`
  /* height: 100vh; */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  /* height: calc(100vh - 52px);
  overflow-y: scroll; */
`;
const ChildWrapper = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  /* padding-top: 30px; */
`;
/**
 * Desktop Children Wrapper
 */
const DesktopChildWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: calc(100vh - 52px);
  width: 100%;
  flex-flow: row wrap;
  overflow-y: scroll;
  padding: 20px 30px;
  align-items: flex-start;
  @media (max-width: 1025px) {
    padding: 20px 20px;
  }
`;
interface IDashboardContentStyle {
  foldStatus: string;
}
const DashboardContentWrapper = styled.div<IDashboardContentStyle>`
  width: ${(p) =>
    p.foldStatus === 'FOLD' ? `calc(100% - 48px)` : `calc(100% - 165px)`};
`;
/**
 * Main Ui Component
 * @param props
 * @constructor
 */
const DesktopDashboardTemplate: React.FC = (props: Props) => {
  const location = useLocation();
  const [isLogin, setIsLogin] = useState(false);
  const [isFold, setIsFold] = useState<'FOLD' | 'UNFOLD'>('UNFOLD');
  // useEffect(() => {
  //   if (location.pathname === "/login") {
  //     setIsLogin(true);
  //   } else {
  //     setIsLogin(false);
  //   }
  // }, [location.pathname]);
  const handleSideBarToggle = (param: string) => {
    const isFold = param === 'fold' ? 'FOLD' : 'UNFOLD';
    setIsFold(isFold);
  };
  return (
    <Fragment>
      {!isLogin && (
        <WrapperDiv>
          <DesktopDashboardHeader></DesktopDashboardHeader>
          <ChildWrapper>
            <DesktopSideBarMenu onToggle={handleSideBarToggle} />
            <DashboardContentWrapper foldStatus={isFold}>
              <DesktopChildWrapper className="custom-scroll">
                {props.children}
              </DesktopChildWrapper>
            </DashboardContentWrapper>
          </ChildWrapper>
        </WrapperDiv>
      )}
      {isLogin && <Fragment>{props.children}</Fragment>}
    </Fragment>
  );
};

export default DesktopDashboardTemplate;
